// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-edit-wrapper .rce-wrapper,\n.tox .tox-edit-area > iframe.tox-edit-area__iframe {\n  background-color: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
